import React, { useContext } from 'react';
import classes from './NoteBlock.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown from 'react-bootstrap/Dropdown';
import { DateHelper } from '@/utils/helpers';
import Note from '@/utils/api/odas/note';
import t from '@/utils/Language/UI-translations';
import { toastContext } from '@/context/toast.context';
import { modalContext } from '@/context/modal.context';

const SHARED_STATUS = { private: 0, organization: 1, public: 2 };

const VisibilityBadge = ({ note, account }) => {
  const orgName = account.data?.affiliation?.organization_name || account.affiliation?.organization_name;

  if (note.shared_status === SHARED_STATUS.private) {
    return (
      <span className={classes.visibilityBadge} title={t('Only you can see this note.')}>
        <FontAwesomeIcon icon={['fas', 'lock']} className={classes.visibilityIcon} />
        {t('Private')}
      </span>
    );
  }
  if (note.shared_status === SHARED_STATUS.organization) {
    return (
      <span className={classes.visibilityBadge} title={t('You and others at your organization can see this note.')}>
        <FontAwesomeIcon icon={['fas', 'lock']} className={classes.visibilityIcon} />
        {orgName || t('Organization')}
      </span>
    );
  }
  if (note.shared_status === SHARED_STATUS.public) {
    return (
      <span className={classes.visibilityBadge} title={t('Anyone who visits this page can see this note.')}>
        <FontAwesomeIcon icon={['fas', 'globe']} className={classes.visibilityIcon} />
        {t('Public')}
      </span>
    );
  }
  return null;
};

const NoteBlock = ({ note, resource, account, onEdit, onDelete }) => {
  const { addToast } = useContext(toastContext);
  const modal = useContext(modalContext);
  const userIsAuthor = note.user_id?.toString() === account?.data?.id?.toString();

  const handleReport = () => {
    modal.enqueueModal({
      name: 'ReportOpportunityNoteModal',
      resource: resource,
      note: note
    });
  };

  const handleDelete = async () => {
    if (!window.confirm(t('Are you sure you want to delete this note?'))) return;
    try {
      await Note.deleteNote(note.id);
      onDelete(note.id);
    } catch {
      addToast({ message: t('An error occurred. Please try again.'), type: 'error' });
    }
  };

  return (
    <div className={classes.noteBlock}>
      <p className={classes.content}>{note.content}</p>
      <div className={classes.footer}>
        <span className={classes.meta}>
          {t('Member')} – {DateHelper.formatDate(note.created_at)}
        </span>
        <div className={classes.footerRight}>
          <VisibilityBadge note={note} account={account} />
          <Dropdown align="end" className={classes.actionDropdown}>
            <Dropdown.Toggle variant="link" className={classes.dropdownToggle} aria-label={t('Note actions')}>
              <FontAwesomeIcon icon={['fas', 'ellipsis']} />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              {userIsAuthor ? (
                <>
                  <Dropdown.Item onClick={() => onEdit(note)}>
                    <FontAwesomeIcon icon={['fas', 'pencil']} className={classes.dropdownIcon} />
                    {t('Edit')}
                  </Dropdown.Item>
                  <Dropdown.Item onClick={handleDelete} className={classes.deleteItem}>
                    <FontAwesomeIcon icon={['fas', 'trash']} className={classes.dropdownIcon} />
                    {t('Delete')}
                  </Dropdown.Item>
                </>
              ) : (
                <Dropdown.Item onClick={handleReport}>
                  <FontAwesomeIcon icon={['fas', 'flag']} className={classes.dropdownIcon} />
                  {t('Report this')}
                </Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
};

export default NoteBlock;
